'use client'

import Topbar from '@/core/components/globals/header/index'
import BreadCrumb from '../bread-crumb'
import { ListIcon } from '@phosphor-icons/react'
import { useUserStore } from '@/store/auth/store'

export default function Header() {
  const toggleSidebar = useUserStore((state) => state.toggleSidebar);
  const user = useUserStore((state) => state.user);

  return (
    <div className="header-container">
      <div className="header-container__menu">
        <ListIcon onClick={toggleSidebar} className="header-container__menu__button" size={35} />
        <BreadCrumb />
      </div>
      {user?.id ? <Topbar /> : <div />}
    </div>
  )
}
